/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 지도 API 실행 Hook
 * 버전 : 1.0
 * 파일명 : LoadMapData.ts
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정일 : 2025-07-09, 강동형 : 저작권 추가, total_cnt setField로 값받을 수 있게 로직 추가
 * 수정일 : 2025-12-30, 강동형 : 무한스크롤로직 추가
 * ================================================================ */

import { BottomSheetType } from 'src/types/SchoolType';
import { useDialogStore } from 'src/stores/DialogStore';
import { useSchoolStore } from 'src/stores/SchoolStore';
import { getSearchSchoolGeoCenter, postSchoolfilter } from 'src/api/SchoolService';
import { toast } from 'react-toastify';

export const LoadMapDataFilter = async () => {
    const {
        months_last_visit,
        selected_Regions,
        edu_level,
        highschool_type,
        special_note,
        school_name,
        setField,
        sort_by,
        sort_order
      } = useDialogStore.getState();
      const { setSchools } = useSchoolStore.getState();

      const trimmed = Object.entries(selected_Regions).map(([wide, cities]) => {
        const trimmedWide = wide.slice(0, 2);
        const filteredCities = cities.length === 1 && cities[0] === '전체' ? [] : cities;
        return [trimmedWide, filteredCities] as [string, string[]];
      });

      
      const response = await postSchoolfilter({
        page: 1,
        sort_by:sort_by,
        sort_order:sort_order,
        school_name,
        months_last_visit: months_last_visit ?? 0,
        loc: trimmed,
        edu_level,
        highschool_type,
        special_note,
      });
    
      const newSchools: BottomSheetType[] = response.data
      
      if(newSchools.length === 0 || Object.keys(trimmed).length === 0){
        toast.error('검색 조건에 맞는 학교가 없습니다.',{autoClose:2000})
        setSchools([])
        setField('total_rows',0)
        return
      }
      // setOpen(false);
      setField('loadBy','default')
      setSchools(newSchools);
      setField('page_Num', 2);
      setField('total_rows',response.total_cnt)
    };

export const LoadMapDataPaging = async () => {
    const {
        months_last_visit,
        selected_Regions,
        edu_level,
        highschool_type,
        special_note,
        school_name,
        page_Num,
        setField,
        sort_by,
        sort_order
    } = useDialogStore.getState();
    
    const { setSchools } = useSchoolStore.getState();
    
    const trimmed = Object.entries(selected_Regions).map(([wide, cities]) => {
        const trimmedWide = wide.slice(0, 2);
        const filteredCities = cities.length === 1 && cities[0] === '전체' ? [] : cities;
        return [trimmedWide, filteredCities] as [string, string[]];
    });

    const response = await postSchoolfilter({
        page: page_Num,
        sort_by:sort_by,
        sort_order:sort_order,
        school_name,
        months_last_visit: months_last_visit ?? 0,
        loc: trimmed,
        edu_level,
        highschool_type,
        special_note,
    });
    const nextPage = page_Num + 1;
    const newSchools = Array.isArray(response?.data) ? (response.data as BottomSheetType[]) : [];
    
    if (newSchools.length === 0) {
        return false;
      }
    setField('loadBy','paging')
    setSchools(newSchools, nextPage);
    setField('page_Num', nextPage);
    setField('total_rows',response.total_cnt)
    return true
    };

interface LoadMapDataCurrentGeoParams{
  min_lon: number,
  min_lat: number,
  max_lon: number,
  max_lat: number
}

export const LoadMapDataCurrentGeo = async ({min_lon,min_lat,max_lon,max_lat}:LoadMapDataCurrentGeoParams) => {
    const {
        months_last_visit,
        edu_level,
        highschool_type,
        special_note,
        school_name,
        setField,
      } = useDialogStore.getState();
      const { setSchools } = useSchoolStore.getState();
      
      const response = await getSearchSchoolGeoCenter({
        min_lon: min_lon,
        min_lat: min_lat,
        max_lon: max_lon,
        max_lat: max_lat,
        school_name,
        months_last_visit: months_last_visit ?? 0,
        edu_level,
        highschool_type,
        special_note,
      });
    
      const newSchools: BottomSheetType[] = response.data
      
      if(newSchools.length === 0 ){
        toast.error('검색 조건에 맞는 학교가 없습니다.',{autoClose:2000})
        setField('total_rows',0)
        setSchools([])
        return
      }
      // setOpen(false);
      setField('loadBy','currentGeo')
      setSchools(newSchools);
      setField('page_Num', 2);
      setField('total_rows',response.total_cnt)
  };

export const LoadMapDataShoolName = async(isNew:boolean)=>{
  const {
        school_name,
        setField,
        page_Num
      } = useDialogStore.getState();
      const { setSchools } = useSchoolStore.getState();

      
      const response = await postSchoolfilter({
        page: isNew ? 1 : page_Num,
        sort_by:'school_name',
        sort_order:'asc',
        school_name,
        months_last_visit:0,
        loc: [["전국", []]],
        edu_level:[0],
        highschool_type:[0],
        special_note:[0],
      });
    
      const newSchools: BottomSheetType[] = response.data
      
      if(newSchools.length === 0){
        if(isNew){
          setSchools([])
        }
        return
      }
      setField('loadBy','schoolName')
      const nextPage = page_Num + 1;
      setSchools(newSchools, isNew ? 1 : nextPage);
      setField('page_Num', nextPage);
      setField('total_rows',response.total_cnt)
}